import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../constants/Languages.js';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';

//img
import noQueryImg from '../../../assets/icons/examples-bg.png';

class AboutPblExamples extends Component {
    static defaultProps = {
        verticalOrient: {WebkitBoxOrient: 'vertical'},
        sliceExpand: 6
    };

    constructor() {
        super();

        this.state = {
            sliceCount: 12
        };
    };

    expandList = () => {
        const { pageData, sliceExpand } = this.props;
        const { sliceCount } = this.state;

        if (this.state.sliceCount < pageData.data.length) {
            this.setState({sliceCount: sliceCount + sliceExpand});
        }
    };

    render() {
        const { clang, pageData, pageDataExamples, match, verticalOrient } = this.props;
        const { sliceCount } = this.state;
        if (!pageData.data) {
            return null;
        }

        return (
            <div className="what-in__examples-container">
                <div className="about-pbl__subpage-content-container examples">
                  <h2>{lang[clang].about_pbl.examples}</h2>
                  <p>{pageDataExamples.acf.query_examples_desc}</p>

                </div>
                <ul className="what-in__examples-list">
                    {pageData.data.slice(0, sliceCount).map((item, index) =>
                      <li key={index} className="what-in__examples-item">
                          <Link to={`${match.url}/${item.id}`} title={item.title.rendered} className="what-in__examples-item--link ">
                              <div className="what-in__examples-item--img" style={{backgroundImage: "url(" + (item.better_featured_image !== null ? item.better_featured_image.source_url : noQueryImg) + ")"}}></div>
                              <span className="what-in__examples-item--circle"></span>
                              <div className="what-in__examples-item--info">
                                  <h3 className="what-in__examples-item--info-title" style={verticalOrient}>
                                      {item.title.rendered}
                                  </h3>
                              </div>
                              <span className="what-in__examples-item--btn">
                                  <span className="what-in__examples-item--btn-icon"></span>
                              </span>
                          </Link>
                      </li>)}
                </ul>
                {sliceCount < pageData.data.length &&
                    <div className="what-in__examples-more--container">
                        <button className="what-in__examples-more" onClick={() => this.expandList()}>Więcej przykładów kwerend</button>
                    </div>}
            </div>
        );
    }
};

AboutPblExamples.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(AboutPblExamples));



// WEBPACK FOOTER //
// ./src/components/about/subpages/AboutPblExamples.js